// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";
import MUINavBar from "../../components/MUINavBar/MUINavBar";
import MDBox from "../../components/MDBox";
import DetailedFooter from "../../pageSections/detailedFooter";
import colors from "../../assets/theme/base/colors";
import { useEffect } from "react";
import breakpoints from "../../assets/theme/base/breakpoints";
import { Axios_Logout, Axios_RefreshToken } from "../../api/axiosFunctions";
import { useDispatch, useSelector } from "react-redux";
import { clearUser, updateToken } from "../../redux/features/user/userSlice";
import { useNavigate } from "react-router-dom";
import constants from "../../common/constants";
import CustomIdleTimer from "./idleTimer";
import AppHost from "../../common/AppHost";

/**
 *
 * @param noCompressed - No Padding, 100% Stretched
 * @returns
 */
function PageLayout({ padding, isAuthenticated, children, noCompressed }) {
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const navigate = useNavigate();

  /* #region useEffect - Refresh Token */
  const REFRESHINTERVAL_MS = 30000;
  useEffect(() => {
    const interval = setInterval(() => {
      if (user.token !== "" && user.token !== undefined) {
        checkIfRefreshTokenRequired();
      }
    }, REFRESHINTERVAL_MS);

    return () => clearInterval(interval); // This represents the unmount function, in which you need to clear your interval to prevent memory leaks.
  }, [user.token, dispatch]);
  /* #endregion */

  useEffect(() => {
    if ((user.token === "" || user.token === undefined) && isAuthenticated)
      navigate("/");
    checkIfRefreshTokenRequired();
  }, []);

  async function checkIfRefreshTokenRequired() {
    if (isAuthenticated) {
      var secondsAway = getSecondsToExpiry();
      if (secondsAway <= 100) {
        // 1000
        await getNewTokens();
      } else {
      }
    }
  }
  async function getNewTokens() {
    var res = await Axios_RefreshToken(user.token, user.refresh_token);
    if ((res?.status ?? 401) === 200) {
      dispatch(updateToken(res.data));
    } else {
      dispatch(clearUser());
      navigate("/login?ref=logout");
    }
  }
  function getSecondsToExpiry() {
    try {
      // Get the current time in milliseconds
      const currentTime = new Date().getTime();

      // Convert the property value to a Date object
      const propertyTime = new Date(user.expiry_time).getTime();

      // Calculate the difference in milliseconds
      const difference = propertyTime - currentTime;

      // Convert milliseconds to minutes
      const minutesAway = Math.round(difference / 1000);
      return minutesAway;
    } catch (ex) {}
    return 0;
  }

  return (
    <>
      <MUINavBar isAuthenticated={isAuthenticated} />
      <MDBox
        component="main"
        justifyContent="center"
        display="flex"
        mt={-5}
        sx={({ breakpoints }) => ({
          bgcolor: colors.JTC.loginGrey,
          p: padding,

          position: "relative",
          minHeight: "120vh",
          [breakpoints.down("md")]: {
            px: -5,
            my: -4,
          },
        })}
      >
        <MDBox
          sx={{
            maxWidth: noCompressed ? "100%" : "85em",
            width: noCompressed ? "100%" : "98%",
          }}
        >
          <CustomIdleTimer
            disabled={
              user.token === "" ||
              !constants.isInactivityFeatureOn ||
              !isAuthenticated
            }
            inactivityThresholdMS={constants.allowedInactivity}
            warningInMS={constants.warningIn}
            timeoutCallback={() => {
              var token = user.token;
              Axios_Logout(token);
              dispatch(clearUser());
              navigate("/login?ref=inactivity");
            }}
          />
          {children}
        </MDBox>
      </MDBox>
      <DetailedFooter />
    </>
  );
}

export default PageLayout;

PageLayout.defaultProps = {
  noCompressed: false,
};
PageLayout.propTypes = {
  children: PropTypes.node.isRequired,
};
